import { Box } from '@mui/material'
import { useEffect } from 'react'
import colors from '../../constants/colors'
import Dropdown from '../Dropdown'
import { ICardAction } from './types'

const CardAction: React.FC<ICardAction> = ({
  options,
  placeholder = '',
  controlRemote,
  fieldName = '',
  selectedValue = 2,
  color = colors.TAG_BORDER_BLUE,
  unregister,
  previewOnly = false,
}) => {
  useEffect(() => {
    return () => {
      if (unregister) {
        unregister(fieldName)
      }
    }
  }, [])
  return (
    <Box sx={{ ma: 0, minWidth: '150px', width: '100%', height: '100%' }}>
      <Dropdown
        control={controlRemote}
        fieldName={fieldName}
        selectedValue={selectedValue}
        options={options}
        placeholder={placeholder}
        className={'t-h-100'}
        sx={{
          '&.MuiSelect-outlined , .MuiOutlinedInput-input': {
            p: '.8rem',
            marginTop: 0,
            alignSelf: 'stretch',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: colors.WHITE,
          },
          '&.MuiSelect-root , .MuiSelect-icon': {
            top: 'auto !important',
            right: '1.2rem',
            fill: colors.TAG_LINES_GRAY,
          },
          minWidth: '20rem',
          width: '100%',
          height: '100%',
          borderRadius: 0,
          borderLeft: `1px solid ${color}`,
          justifyContent: 'center',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        previewOnly={previewOnly}
        typographyVariant={'h4'}
      />
    </Box>
  )
}

export default CardAction
